/* eslint-disable max-len */
import styles from './style.module.scss';

const AgeTipModal = ({
  modalRef,
}) => {
  const onClose = () => {
    modalRef.current.close();
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.modalClose}
        onClick={onClose}
      />
      <div className={styles.content}>
        <figure className={styles.titlePic} />
        <div className={styles.text}>
          1）本游戏是一款角色扮演类经营游戏，适用于年满16周岁及以上的用户，建议未成年人在家长监护下使用游戏产品。
          <br /><br />
          2）本游戏为架空背景，其中涉及的人物和组织，与现实社会形象无关。游戏玩法基于卡牌收集和培养，设有玩家与游戏角色之间不可自主编辑的文字和语音互动，鼓励玩家树立健康的人际交往观念。游戏中没有基于文字和语音的陌生人社交系统。
          <br /><br />
          3）游戏中有用户实名认证系统，认证为未成年人的用户将接受以下管理：
          <br /><br />
          游戏中部分玩法和道具需要付费。未满8周岁的用户不能付费；8周岁以上未满16周岁的未成年人用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币；16周岁以上的未成年人用户，单次充值金额不得超过100元人民币，每月充值金额不得超过400元人民币。
          <br /><br />
          未成年人用户仅可在周五、周六、周日和法定节假日每日20:00-21:00进行一小时游戏体验，其余时间均不得使用。
          <br /><br />
          不进行实名认证或处于认证中的用户，将无法登录游戏。
          <br /><br />
          4）本游戏为玩家单人游戏模式，需要玩家完成任务来拯救濒临破产的公司、建立良好的人际关系，并应对生活中的各种危机和挑战。游戏设有重要事项提醒、背单词功能以及学习和工作模式，有助于帮助玩家养成劳逸结合的生活习惯。
        </div>

      </div>
    </div>
  );
};

export default AgeTipModal;
